<p-toast #appToast/>
<p-confirmDialog
    #appConfirm
    key="positionDialog" 
    position="center" 
    rejectButtonStyleClass="p-button-outlined" />
<router-outlet />
